import { useNavigate } from 'react-router-dom'
import { RoutePaths, UserPermissions } from '../constants/constants'
import { usePermissions } from './usePermissions'
import { useEffect } from 'react'

export const useRoutePermission = (
    required: UserPermissions | UserPermissions[],
    redirectTo?: string,
): boolean => {
    const { hasPermission } = usePermissions()
    const navigate = useNavigate()

    const allowed = hasPermission(required)

    useEffect(() => {
        if (!allowed) {
            navigate(redirectTo ?? RoutePaths.Home, {
                replace: false,
            })
        }
    }, [allowed, navigate, redirectTo])

    return allowed
}
